<template>
  <div>
    <AtelierForm @edited="goToAtelierInfo" :item="tenant" />
  </div>
</template>

<script>

import AtelierForm from '@/components/forms/AtelierForm.vue';
import { useUserStore } from '@/store/userStore';
import { fetchTenant } from '@/helpers/userMethods';
export default {
  name: "AtelierEdit",
  components: {
    AtelierForm
  },
  computed: {
    userStore() {
      return useUserStore();
    },
    tenant() {
      return this.userStore.tenant || {};
    },
  },

  methods: {
    goToAtelierInfo() {
      this.fetchTenant(true)
      this.$router.push({ name: 'atelier.view' })
    },
    fetchTenant,
  },

}
</script>